import messages from './messages';

import AppStoreIcon from './footer-app-store-btn.svg';
import GooglePlayIcon from './footer-google-play-btn.svg';

export { default as logoHeader } from './logo.svg';
export { default as footerLogo } from './logo-footer.png';
export { default as svgSprite } from './svg-sprite.svg';

export const footerIcons = [];

export const footerLinks = [
  {
    href: null,
    configKey: 'TOS_URL_LINK',
    message: messages['footer.staticPages.tos'],
    targetBlank: true,
  },
  {
    href: null,
    configKey: 'US_PRIVACY_FOOTER_LINK',
    message: messages['footer.staticPages.privacy'],
    targetBlank: false,
  },
  {
    href: null,
    configKey: 'SUPPORT_URL',
    message: messages['footer.staticPages.help'],
    targetBlank: false,
  },
];
export const storeLinks = [
  {
    href: 'https://apps.apple.com/us/app/starbucks-global-academy/id1200272516',
    icon: AppStoreIcon,
    message: messages['footer.storeAppStore'],
    targetBlank: true,
  },
  {
    href: 'https://play.google.com/store/apps/details?id=com.starbucksglobalacademy.courses',
    icon: GooglePlayIcon,
    message: messages['footer.storeGoogleStore'],
    targetBlank: true,
  },
];

export const isFooterDark = true;

export const displayCreatedByBlock = false;
